<template>
  <div>
    <span v-if="hasText()" @click="handleClick">{{text}}</span>
    <span @click="handleClick"><i class="material-icons bold">arrow_back</i></span>
  </div>
</template>

<script>
export default {
  name: 'GoBackButton',
  props: {
    text: {
      default: ''
    }
  },
  methods: {
    handleClick () {
      this.$router.go(-1);
    },
    hasText () {
      return this.text.length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
  a {
    color: blue;
  }
  div {
    text-align: left;
    // padding: 0 1em;
    margin-bottom: 1em;
  }

  span {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/GoBackButton.vue